import React from 'react';
import styles from './About.module.css';

const About = () => {
  const features = [
    {
      icon: 'fa fa-qrcode',
      title: 'Чеки с QR кодом',
      description: 'Производим чеки на официальном кассовом оборудовании с валидным QR кодом (от работающей гостиницы).'
    },
    {
      icon: 'fa fa-rocket',
      title: 'Доставка по Челябинску',
      description: 'Осуществляем доставку гостиничных чеков по городу. Возможна бесплатная доставка при заселении на ⩾ 4 суток.'
    },
    {
      icon: 'fa fa-child',
      title: 'Приемлемая стоимость',
      description: 'Мы держим цены ниже средней по рынку подобных услуг: 5-10 % от суммы вашего чека.'
    },
    {
      icon: 'fa fa-handshake-o',
      title: 'Работаем официально',
      description: 'Мы проводим реальное оформление проживания и платим налоги ⇄ чеки подтверждаются.'
    }
  ];

  return (
    <section id="about" className={`section ${styles.about}`}>
      <div className="container">
        <h2 className={styles.sectionTitle}>О нас</h2>
        <div className={styles.aboutContent}>
          <div className={styles.aboutText}>
            <p>
              Наша организация, «CHEKi74» предоставляет клиентам гостиничные чеки с qr кодом и другие документы, 
              необходимые для отчёта по командировке, при этом является действующей гостиницей. 
              <span className={styles.highlight}> Этот пакет гостиничных документов будет необходим для подтверждения 
              проживания в нашем номером фонде для последующего возмещения этих затрат в бухгалтерии.</span>
            </p>
            <p className={styles.darkText}>
              Практически каждый работник частной или государственной компании имеет желание дополнительно заработать 
              за время командировки. Можно попытаться сэкономить на питании или как то сократить транспортные расходы, 
              но лучшим вариантом будет реализовать возмещение проживания в гостинице.
            </p>
            <p className={styles.darkerText}>
              Следующий шаг - это <a href="#contact" className={styles.link}>обращение</a> к нашим специалистам для 
              оформления всех необходимых отчетных документов, включая гостиничные чеки. Мы оперативно обрабатываем 
              ваши заявки, подготавливаем и доставляем документы по нужному адресу в Челябинске.
              <span className={styles.highlightDark}> Так же, для удобства, мы можем оформить закрывающие документы 
              "задним числом", при этом гарантируем 100%-е подтверждение, потому что работаем официально и в полном 
              объёме платим налоги.</span>
            </p>
          </div>
          
          <div className={styles.features}>
            {features.map((feature, index) => (
              <div key={index} className={`card ${styles.featureCard}`}>
                <div className={styles.featureIcon}>
                  <i className={feature.icon}></i>
                </div>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
                <p className={styles.featureDescription}>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;